<template>
  <div >
    <div class="content" :style="{height:$store.state.videoTabHeight-45+'px'}">
        <!--<router-link to="/home" class="position">
            <img class="icon" src="../../assets/shouye.png" alt="">
        </router-link>-->

        <!--todo new 20260305 新加返回搜索页方法 start-->
        <img
                class="position icon"
                src="../../assets/shouye.png"
                alt="返回/首页"
                @click="goBack"
                style="cursor: pointer;"
        >
        <!--todo new 20260305 新加返回搜索页方法 end-->

        <!-- <video :poster="posterSrc" :src="videoSrc" controls id="ckplayer_a1" x5-video-player-type="h5" preload="metadata" playsinline="true" webkit-playsinline="true"  x-webkit-airplay="true" x5-video-orientation="portraint" x5-video-player-fullscreen="true" ></video> -->
        <!-- x5-video-player-type="h5" 和 x5-playsinline="true" 冲突-->
        <video v-show='isAndroid' controlslist="nodownload" :poster="posterSrc" :src="videoSrc" controls  x-webkit-airplay="true" x5-playsinline="true"  webkit-playsinline="true" playsinline="true"></video>
        <div v-show='!isAndroid' id="dplayer"></div>
    </div>
  </div>
</template>

<script>
import DPlayer from 'dplayer';
import { mapState, mapActions } from "vuex";
import https from '../../https.js'
 import wx from 'weixin-js-sdk'
export default {
  inject:["reload"],
  data () {
    return {
      posterSrc:'',
      videoSrc:"",
      post_title:"",   //分享描述，video的标题
      dp:null,
      isAndroid:false
    }
  },
   computed:{
      ...mapState([
        'videoMsg'
      ])
  },
  created(){
    this.judgeDevie()
  },
  mounted(){
  },
  methods:{
    judgeDevie(){
         if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
             this.isAndroid=false
         }else if (/(Android)/i.test(navigator.userAgent)) {
             this.isAndroid=true
         }
     },
    //微信分享
      wxshareArtwork(){
                var that=this;
                var url=new Object();
                url.url=window.location.href.split('#')[0];
                 https.fetchPost("login/wxShare",url)
                  .then(res=>{
                        var data=res.data.data;
                        var appId=data.appid;
                        var timestamp=data.timestamp;
                        var nonceStr=data.noncestr;
                        var signature=data.signature;
                        wx.config({
                            debug: false,
                            appId: data.appid,
                            timestamp: data.timestamp,
                            nonceStr: data.noncestr,
                            signature: data.signature,
                            jsApiList: [
                                'onMenuShareTimeline',
                                'onMenuShareAppMessage'
                            ]
                        });
                        wx.ready( function() {
                            var title=that.$store.state.title2;
                            var link=window.location.href.split('#')[0]+'static_wap/html/redirect.html?app3Redirect='+encodeURIComponent(window.location.href);
                            // var thumbnail=that.$store.state.videoMsg.thumbnail;
                            // var imgUrl="https://book-yy.oss-cn-zhangjiakou.aliyuncs.com/static/share_def.png";  //分享默认图片
                            if(that.$store.state.videoMsg==""){
                               var imgUrl="https://book-yy.oss-cn-zhangjiakou.aliyuncs.com/static/share_def.png";  //分享默认图片
                               var desc="";     //描述信息
                            }else{
                                var imgUrl=that.posterSrc;  //分享默认图片
                                var desc=that.post_title;     //描述信息
                            }
                            let sinfo=new Object()
                            sinfo.shareTitle=title
                            sinfo.shareDesc=desc
                            sinfo.shareUrl=link
                            sinfo.shareImg=imgUrl
                            sessionStorage.setItem('sinfo',JSON.stringify(sinfo))

                            wx.onMenuShareTimeline({//朋友圈
                                title: title, // 分享标题
                                link: link, // 分享链接
                                imgUrl: imgUrl, // 分享图标
                                success: function () {
                                    
                                },
                                cancel: function () {
                                    
                                }
                            });
                            wx.onMenuShareAppMessage({//好友
                                title: title, // 分享标题
                                desc:desc, //
                                link: link, // 分享链接
                                imgUrl: imgUrl, // 分享图标
                                type: '', // 分享类型,music、video或link，不填默认为link
                                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                                success: function () {},
                                cancel: function () {
                                
                                }
                            });
                        })
                    
                  });  
                
            },

    // 获取资源路径
    getSrc(){
      this.posterSrc=this.videoMsg.thumbnail
      this.videoSrc=this.videoMsg.source_path[0];
      this.post_title=this.videoMsg.post_title;
      if(this.isAndroid==false){
        this.initVideo(this.videoSrc,this.posterSrc)
      }
      this.wxshareArtwork()
    },
    initVideo(videoSrc,posterSrc){
      this.dp = new DPlayer({
          container: document.getElementById('dplayer'),
          autoplay: false,
          theme: '#00878b',
          loop: false,
          lang: 'zh-cn',
          volume: 0.7,
          video: {
            url: videoSrc,
            pic: posterSrc,
            type: 'auto',
          },
            mutex: true
        });
      // 禁止右键下载视频
        document.oncontextmenu=new Function("event.returnValue=false;");
        document.onselectstart=new Function("event.returnValue=false;");
        document.getElementsByClassName('dplayer-full-in-icon')[0].style.display='none'
        // // 修改循环播放显示
        document.getElementsByClassName('dplayer-setting')[0].style.display='none'
        
       
    },
      //todo new 20260305 新加返回搜索页方法 start
      goBack(){
          //todo new 20260305 添加搜索关键字参数
          var keyWord=this.$route.query.keyWord;//keyWord搜索关键字
          console.log(keyWord);
          if(keyWord){
              console.log(keyWord);
              //this.$router.back();
              //this.$router.go(-1);
              this.$router.push(`search?keyWord=${keyWord}`);
          }else{
              //this.$router.push({ name: 'home' });
              this.$router.push('/');
          }
      },
      //todo new 20260305 新加返回搜索页方法 end
  },

 
  watch:{
    videoMsg(){
      this.getSrc()
    },
    
  }
}
</script>
<style>
  #dplayer{
    width:100%;
    height: 100%;
  }
</style>
<style scoped>
  .content{
      width:100%;
      position:relative;
  }
  video{
      width:100%;
      height:100%;
      cursor: pointer;
  }
  .position{
        display: block;
        position: absolute;;
        color:#ccc;
        top: 10px;
        left: 12px;
        z-index:9999;
    }
   .icon{
        width:44px;
    }
    video::-internal-media-controls-download-button {
        display:none;
    }
    video::-webkit-media-controls-enclosure {
        overflow:hidden;
    }
    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }
</style>



// WEBPACK FOOTER //
// src/components/common/video.vue